module.exports = __webpack_public_path__ + "static/Profile-Ian-Ray-330aa458189d56c3ffb3245b8321d278.png";